
import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ClientInformation } from './ClientInformation';

export function ClientDetailsTab ({menuArray,userData,clientData}) {
  return(
    <Collapse in={menuArray[0]} className="m-0 p-0 ">
        <Row id="clientDetailsTab" className="m-0 p-0">
            <Col xs={12} xl={6} className="m-0 p-2 pt-0">
              <ClientInformation userData={userData} clientData={clientData}/>
            </Col>
            <Col xs={12} xl={6} className="m-0 p-2 pt-0">
            </Col>
        </Row>
    </Collapse>
    );
}